
import { defineComponent, ref, watch } from 'vue';
import { Codemirror } from 'vue-codemirror'
import { json } from '@codemirror/lang-json'
import { oneDark } from '@codemirror/theme-one-dark'
import { Diagnostic, linter } from "@codemirror/lint"
import { parse } from 'jsonc-parser';
import format from 'json-format'

export default defineComponent({
    name: 'json-code',
    components: { Codemirror },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editable: { // 是否显示编辑切换功能， 默认不显示按钮
            type: Boolean,
            default: false
        },
        code: {
            type: String,
            default: '{}'
        }
    },
    emits: {
        // 声明 json-change 事件，并指定其类型为文本
        'json-change': (value: string) => true,
    },
    setup(props, context) {

        // 格式失败的回退处理
        const jsonFormatter = (val: string): string => {
            try {
                return format(JSON.parse(val))
            } catch (e: unknown) {
                return val
            }
        }

        const jsonVal = ref(jsonFormatter(props.code));
        const handleChange = (value: string) => {
            context.emit('json-change', value);
        }
        const beautify = () => {
            jsonVal.value = jsonFormatter(jsonVal.value);
        }

        // 监听父组件修改属性值 实时同步
        watch(() => props.code, (val) => {
            jsonVal.value = jsonFormatter(val); // 无需 jsonFormatter 校验
        })

        const edit = ref(props.editable);
        const locked = ref(props.disabled);
        const extensions = [
            json(),
            oneDark,
            linter((view) => {
                const result: Diagnostic[] = [];
                const errors = [];
                parse(view.state.doc.toString(), errors);
                if (errors.length > 0) {
                    errors.forEach(error => {
                        result.push({
                            from: error['offset'],
                            to: error['offset'] + error['length'],
                            message: error['error'],
                            severity: 'error'
                        });
                    });
                }
                return result;
            })];

        return {
            edit,
            jsonVal,
            locked,
            extensions,
            handleChange,
            beautify,
        }
    }
})
